<template>
  <div>
    <h2>
      Reconciliation & Invoicing
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
      :model="formData"
    >
      <el-form-item
        label="Default Service"
        prop="prefixRequired"
      >
        <el-select
          v-model="formData.default_service"
          filterable
          placeholder="Search Service"
          :loading="isLoadingServices"
          class="w-100"
          value-key="id"
          clearable
          @clear="formData.default_service = null"
        >
          <el-option
            v-for="service in services"
            :key="service.id"
            :label="service.name"
            :value="service"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Default Fuel Group">
        <el-select
          v-model="formData.default_fuel_group"
          :remote-method="querySearch"
          placeholder="Default Fuel Group"
          :trigger-on-focus="false"
          placement="top"
          value-key="id"
          class="w-100"
          filterable
          remote
          clearable
          :loading="isLoadingServices"
          @change="handleSelect"
          @focus="updateCount++"
          @clear="formData.default_fuel_group = null"
        >
          <el-option
            v-for="item in fuels"
            :key="item.fuels[0].id"
            :label="item.fuels[0].name"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Default Zone Parent">
        <el-switch
          v-model="formData.default_zone_parent"
          active-text="Always check for parent zone during reconciliation"
        />
      </el-form-item>
      <el-form-item label="Inv Template">
        <el-input
          v-model="formData.inv_template"
          placeholder="Inv Template"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isLoadingServices: false,
      services: [],
      fuelName: null,
      updateCount: 0,
      fuels: []
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
      }).then(res => {
        this.services = res
      })
        .finally(() => {
          this.isLoadingServices = false
        })
      if (!this.$props.formData.default_fuel_group) {
        this.$props.formData.default_fuel_group = {}
        this.$props.formData.default_fuel_group.fuels = new this.$sdk.fuel()
      } else if (this.$props.formData.default_fuel_group.fuels) {
        this.querySearch(this.$props.formData.default_fuel_group.fuels[0].name)
      }
    },
    querySearch (queryString) {
      this.isLoadingServices = true
      this.$sdk.fuel_group.list(builder => {
        builder.include = ['fuels']
        builder.filters = { 'fuel_group_has_fuels_by_name': queryString }
      }).then(res => {
        this.fuels = res
        this.isLoadingServices = false
      })
    },
    handleSelect (item) {
      this.formData.default_fuel_group = item
    }
  }
}
</script>
